// src/components/FaunaRace/FaunaModeScreen.js
import React from 'react';
import { faunaData } from '../../gameLogics/faunaRaceData';
import styles from './FaunaRace.module.css';
import { ACTIONS } from './FaunaRaceGame';

function FaunaModeScreen({ dispatch }) {
    return (
        <div className={styles.container}>
            <div className={styles.modeScreen}>
                <h2 className={styles.modeTitle}>PILIH MODE KLASIFIKASI</h2>
                
                <div className={styles.modeGrid}>
                    {Object.keys(faunaData).map(modeKey => (
                        <div 
                            key={modeKey} 
                            className={styles.modeButton} 
                            onClick={() => dispatch({ type: ACTIONS.SELECT_MODE, payload: { mode: modeKey } })}
                        >
                            {/* Ambil dan render ikon dari data */}
                            <div className={styles.modeIcon}>{faunaData[modeKey].icon}</div>
                            <div className={styles.modeLabel}>{faunaData[modeKey].name.toUpperCase()}</div>
                        </div>
                    ))}
                </div>
                
                 {/* 
                  ==============================================
                  PERBAIKAN DI SINI:
                  Gabungkan kedua kelas menggunakan template literal.
                  `${styles.woodButton}` akan menerapkan semua gaya dasar.
                  `${styles.backButton}` akan menerapkan gaya spesifik yang menimpa gaya dasar.
                  ==============================================
                */}
                <button 
                    className={`${styles.woodButton} ${styles.backButton}`} 
                    onClick={() => dispatch({ type: ACTIONS.GO_TO_SCREEN, payload: { screen: 'home' } })}
                >
                    Kembali
                </button>
            </div>
        </div>
    );
}

export default FaunaModeScreen;